export const currencyInputFormatter = (value, showAsNegative = false) => {
    const numberValue = Number(value);
    //This allows user to input by decimal first in input when we divide the value by 100
    const val = showAsNegative ? -1 * (numberValue / 100) : numberValue / 100;

    const stringValue = String(val);
    const amount = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(stringValue);
    //We want to show a negative sign in front of the 0 if showAsNegative is true
    if (val === 0 && showAsNegative) {
        return `-${amount}`;
    }
    return amount;
};
